module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAqUlEQVRYR+2VwQ3CMBRDbdRBOgqiDMAGsAC0nYB0AlqYgD1y6CgdJFI4cKuqKocvJQdnANt6sn+IzI+Z/aEAIiAChRI4vW844Gp7IzjA3+e15jaB5nMBY2ccwKUHsHXeVSu0AyKQnUAzjSRbyxwRcYBvXdoMj68aVVVbBkAIC+Z+SQtg6rwvphkWSuBfQtvPKIRvegnPkyP4tOxiBHr4x6gViIAIiMCawA9Y0SAhD3uevQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list.png
// module id = TV/B
// module chunks = 16